import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _9kIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"9k"} ref={ref}/>
});

_9kIcon.displayName = "_9kIcon";
